import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Line } from 'react-chartjs-2';
import moment from 'moment';
import Title from './Title';
import { Button } from '@material-tailwind/react';
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Title as ChartTitle,
  Tooltip,
  Legend,
} from 'chart.js';
import 'chartjs-adapter-moment';

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  ChartTitle,
  Tooltip,
  Legend
);

const Chart = ({ orders }) => {
  const theme = useTheme();
  const [startDate, setStartDate] = useState(moment().subtract(1, 'weeks').startOf('day'));
  const [endDate, setEndDate] = useState(moment().add(4, 'weeks'));

  const aggregatedData = orders.reduce((acc, order) => {
    if (order.status === 'Đã thanh toán') {
      const date = moment(order.orderDate).format('DD-MM-YYYY');
      const profit = order.totalPrice * 0.08;
      if (!acc[date]) {
        acc[date] = 0;
      }
      acc[date] += profit;
    }
    return acc;
  }, {});

  const chartData = [];
  let currentDate = moment(startDate);
  while (currentDate.isBefore(endDate)) {
    const dateStr = currentDate.format('DD-MM-YYYY');
    chartData.push({
      date: dateStr,
      amount: aggregatedData[dateStr] || 0,
    });
    currentDate = currentDate.add(1, 'day');
  }

  const data = {
    labels: chartData.map((d) => d.date),
    datasets: [
      {
        label: 'Tổng doanh thu',
        data: chartData.map((d) => d.amount),
        borderColor: theme.palette.primary.main,
        fill: false,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: 'category',
        labels: chartData.map((d) => d.date),
        title: {
          display: true,
          text: 'Date',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Total Profit (VNĐ)',
        },
        beginAtZero: true,
      },
    },
    onClick: (event, elements) => {
      // Handle click event if needed
      console.log('Clicked on chart:', event, elements);
    },
  };

  const handlePrevious = () => {
    setStartDate(startDate.clone().subtract(1, 'weeks'));
    setEndDate(endDate.clone().subtract(1, 'weeks'));
  };

  const handleNext = () => {
    setStartDate(startDate.clone().add(1, 'weeks'));
    setEndDate(endDate.clone().add(1, 'weeks'));
  };

  return (
    <React.Fragment>
      <Title>Biểu đồ doanh thu</Title>
      <div style={{ width: '90%', flexGrow: 1, overflow: 'hidden' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
          <Button color='deep-purple' onClick={handlePrevious} style={{ marginRight: '10px' }}>Tuần trước</Button>
          <Button color='light-green' onClick={handleNext}>Tuần sau</Button>
        </div>
        <Line data={data} options={options} />
      </div>
    </React.Fragment>
  );
};

export default Chart;
